// extracted by mini-css-extract-plugin
module.exports = {"copy-button":"style_copy-button__Q4NMW"};